export default "__VITE_ASSET__Buh_KhLl__"